import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { filterReducer} from './filter/filter.reducer';
import { FilterState } from './filter/filter.model';

export type Action = {
  type: string,
  data?: any
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ["filter"],
    rehydrate: true,
    storageKeySerializer: (key) => 'orange_rse_' + key
  })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

export interface AppState {
  filter: FilterState,
}

export const reducers: ActionReducerMap<AppState> = {
  filter: filterReducer
};




// WEBPACK FOOTER //
// ./src/app/store/index.ts